import React, {useEffect, useMemo, useState} from "react";
import {getIndividualSetting} from "../../../../api/user/UserAccountService";
import {initHeaderOrders, simmsColumnsToJsGridHeaders} from "../../../../components/commonmethod/CommonMethod";
import DetailHistoryLinkedList from "./DetailHistoryLinkedList";
import DetailLinkedPagination from "./DetailLinkedPagination";
import "../detailHistoryLinkedList.css";

/**
 * 상세 화면 이력관리 탭 — 공통 컴팩트 이력 목록
 */
function HistoryLinkedListView({headerDefinition, settingKey, newData, onPageChange, children, className = ""}) {
    const [header, setHeader] = useState({order: headerDefinition, exclude: []});

    useEffect(() => {
        if (!settingKey) {
            setHeader({order: headerDefinition, exclude: []});
            return;
        }
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, headerDefinition, setHeader, [], () => {}, () => {}, settingKey);
        });
    }, [headerDefinition, settingKey]);

    const columns = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const rows = newData?.content ?? [];
    const pageable = newData?.pageable ?? {};

    return (
        <div
            className={`detail-history-linked-root asset-detail-linked-list asset-detail-linked-list--history flex min-h-0 min-w-0 flex-1 flex-col w-full h-full ${className}`.trim()}
        >
            {children ? <div className="asset-detail-linked-toolbar shrink-0">{children}</div> : null}

            <div className="asset-detail-linked-body">
                {rows.length === 0 ? (
                    <div className="asset-linked-grid-empty" role="status">
                        조회된 데이터가 없습니다.
                    </div>
                ) : (
                    <div className="asset-linked-list-scroll asset-linked-list-scroll--history">
                        <DetailHistoryLinkedList rows={rows} columns={columns} />
                    </div>
                )}
                <DetailLinkedPagination pageable={pageable} onPageChange={onPageChange} />
            </div>
        </div>
    );
}

export default HistoryLinkedListView;
